//import { Address } from './address.model';

import { BaseModel } from 'app/@core/models/_base.model';

export class User extends BaseModel {
  id: number;
  username: string;
  name: string;
  password: string;
  email: string;
  accessToken: string;
  refreshToken: string;
  roles: number[];
  pic: string;
  profile_picture_path: string;
  fullname: string;
  occupation: string;
  companyName: string;
  phone: string;
  //address: Address;

  clear(): void {
    this.id = undefined;
    this.username = '';
    this.password = '';
    this.email = '';
    this.roles = [];
    this.fullname = '';
    this.accessToken = 'access-token-' + Math.random();
    this.refreshToken = 'access-token-' + Math.random();
    this.pic = './assets/media/users/default.jpg';
    this.occupation = '';
    this.companyName = '';
    this.phone = '';
    // this.address = new Address();
    // this.address.clear();
  }
}
